import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { useCallback, useEffect } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";

import DefaultFormInput from "../../../../../../common/components/default_form_input";
import FormContainer from "../../../../../../common/components/form_container";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import {
  PgtoContratoFinanceiroForm,
} from "../../../schemas/ContratoFinanceiro_cadastro/PgtoContratoFinanceiro_form";
import { FormMaskedInput } from "../../../../../../common/components/masked_inputs/react_forms/form_masked_input";
import { DefaultFormMoneyInput } from "../../../../../../common/components/default_form_money_input";
import { FormRadioGroupInput } from "../../../../../../common/components/masked_inputs/react_forms/form_radio_group_input";

/**
 * CadastroPagamentoModal
 */

type Props = {
  open: boolean,
  saving: boolean,
  hookForm: UseFormReturn<PgtoContratoFinanceiroForm>,

  projetarMeses: number,
  pagamentoAvista: number,
  entrada: number,
  dividirEntrada: number,

  valorFinanciado: number | undefined,
  valorRestante: number | undefined,
  parcelaSecundaria: boolean,

  onSubmit: (form: PgtoContratoFinanceiroForm) => void,
  onClose: () => void,
};

export const ConfigurarPgtosModal = ({
  projetarMeses,
  dividirEntrada,
  pagamentoAvista,
  entrada,
  valorFinanciado,
  valorRestante,
  hookForm,
  open,
  saving,
  parcelaSecundaria,
  onSubmit,
  onClose,

}: Props) => {
  const valorEntrada = hookForm.watch("valorEntrada");

  useEffect(() => {
    if (valorRestante && valorEntrada) {
      const restante = valorRestante - valorEntrada;
      hookForm.setValue("valorAParcelar", restante > 0 ? restante : 0);
    } else if (valorRestante) {
      hookForm.setValue("valorAParcelar", valorRestante);
    }
  }, [hookForm, valorEntrada, valorRestante]);


  const handleSubmit = useCallback((form: PgtoContratoFinanceiroForm) => {
    if (!saving)
      onSubmit(form);

  }, [saving, onSubmit]);

  const handleClose = useCallback(() => {
    if (!saving) onClose();

  }, [saving, onClose]);

  return (

    <Dialog
      open={open}
      slotProps={{
        paper: {
          component: 'form',
          onSubmit: hookForm.handleSubmit(handleSubmit),
        }
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "70rem",
          },
        },
      }}>

      <DialogTitle>
        Configurar pagamentos contrato
      </DialogTitle>

      <DialogContent>
        <ModalLoading loading={saving}>
          <FormContainer title={"Informações"} arrangement="fullRow">
            <>

              <div className="w-full bg-white p-4 rounded-2xl shadow-sm">
                <div className="grid grid-cols-1 gap-4">
                  <div className="flex items-center justify-between">
                    <label className="font-medium text-gray-700">
                      Valor Financiado: {valorFinanciado?.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL"
                      })}
                    </label>
                  </div>
                  <div className="flex items-center justify-between">
                    <label className="font-medium text-gray-700">
                      Valor Restante:   {valorRestante?.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL"
                      })}
                    </label>
                  </div>
                </div>
              </div>

              <div className="w-full bg-white p-4 rounded-2xl shadow-sm">
                <div className="grid grid-cols-1">
                  <div className="flex items-center justify-between gap-4">
                    <label className="font-medium text-gray-700">Pagamento à vista:</label>
                    <FormRadioGroupInput
                      name="pagamentoAvista"
                      label=""
                      readOnly={saving}
                      options={[
                        { id: 1, label: "Sim" },
                        { id: 0, label: "Não" },
                      ]}
                      reactHookForm={hookForm}
                    />

                  </div>
                </div>
              </div>

              {
                pagamentoAvista === 1 &&
                <div className="w-[50%]">
                  <FormDatePickerInput
                    name='dataPrimeiroPgto'
                    required={true}
                    label='Data pagamento'
                    readOnly={saving}
                    reactHookForm={hookForm} />
                </div>
              }

              {
                pagamentoAvista === 0
                &&
                <div>

                  <div className="w-full bg-white p-4 rounded-2xl shadow-sm">
                    {
                      !parcelaSecundaria
                      &&
                      <div className="grid grid-cols-1 gap-4 pb-3">
                        <div className="flex flex-row justify-between gap-20 items-center">
                          <label className="font-medium text-gray-700 " >Entrada</label>
                          <FormRadioGroupInput
                            name="entrada"
                            label=""
                            readOnly={saving}
                            options={[
                              { id: 1, label: "Sim" },
                              { id: 0, label: "Não" },
                            ]}
                            reactHookForm={hookForm}
                          />
                        </div>
                      </div>

                    }

                    {
                      entrada === 1
                      &&
                      <div>
                        <div className="flex flex-row justify-between gap-12 items-center mb-3">
                          <label className="font-medium text-gray-700 " >Dividir Entrada</label>
                          <FormRadioGroupInput
                            name="dividirEntrada"
                            label=""
                            readOnly={saving}
                            options={[
                              { id: 1, label: "Sim" },
                              { id: 0, label: "Não" },
                            ]}
                            reactHookForm={hookForm}
                          />

                        </div>

                        <div className="flex flex-row gap-4 pb-3">
                          <div className="w-full">
                            <DefaultFormMoneyInput
                              name='valorEntrada'
                              label='Valor da Entrada'
                              required={true}
                              readOnly={saving}
                              reactHookForm={hookForm}
                            />
                          </div>

                          <div className="w-full">
                            <FormDatePickerInput
                              name='dataPgtoEntrada'
                              label='Data da Entrada'
                              required={true}
                              readOnly={saving}
                              reactHookForm={hookForm}
                            />
                          </div>
                          {
                            dividirEntrada === 1
                            &&
                            <div className="w-[60%] pb-3">
                              <FormMaskedInput
                                name={'numeroParcelasEntrada'}
                                label={"Nro parcelas da entrada?"}
                                required={true}
                                mask='000'
                                maskPlaceholder="___"
                                reactHookForm={hookForm}
                              />
                            </div>
                          }
                        </div>
                      </div>
                    }

                    <div className="grid grid-cols-1 gap-4 pb-3">
                      <div className="flex flex-row items-center gap-9">
                        <label className="  font-medium text-gray-700 " >Pagamento Em:</label>
                        <FormRadioGroupInput
                          name="projetarMeses"
                          label=""
                          readOnly={saving}
                          options={[
                            { id: 0, label: "Projetar Meses Futuros" },
                            { id: 1, label: "Informar intervalo de dias" },
                          ]}
                          reactHookForm={hookForm}
                        />

                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4 pb-3">
                      <div className="w-full">
                        <DefaultFormMoneyInput
                          name='valorAParcelar'
                          label='Valor do contrato a parcelar'
                          required={true}
                          readOnly={saving}
                          reactHookForm={hookForm}
                        />
                      </div>

                      <div className="w-full">
                        <FormDatePickerInput
                          name='dataPrimeiroPgto'
                          required={true}
                          label='Data pagamento'
                          readOnly={saving}
                          reactHookForm={hookForm} />
                      </div>

                      <div className="w-full">
                        <FormMaskedInput
                          name={'numeroParcelas'}
                          label={"Gerar quantas parcelas do contrato?"}
                          required={true}
                          mask='000'
                          maskPlaceholder="___"
                          reactHookForm={hookForm}
                        />
                      </div>
                    </div>

                    {
                      projetarMeses === 1
                      &&
                      <FormMaskedInput
                        name='intervaloDias'
                        label="Nro de dias entre as parcelas"
                        mask='000'
                        maskPlaceholder="___"
                        reactHookForm={hookForm}
                      />
                    }

                  </div>

                </div>
              }

              <DefaultFormInput
                name='observacao'
                label='Informações Gerais'
                readOnly={saving}
                multiline={true}
                rows={5}
                reactHookForm={hookForm}
              />

            </>
          </FormContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <div className="w-full h-full items-center justify-end flex px-4 pb-4 gap-4">

          <div className="flex flex-row gap-2">
            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1
                className="text-sm text-black dark:text-white"
                onClick={handleClose}>
                Cancelar
              </h1>
            </div>

            <div className="w-[120px]">
              {saving ? (
                <PrimaryButton
                  buttonColor="primary-green">
                  Salvando...
                </PrimaryButton>
              ) : (
                <PrimaryButton
                  type="submit"
                  buttonColor="primary-green">
                  Salvar
                </PrimaryButton>
              )}
            </div>
          </div>
        </div>
      </DialogActions>
    </Dialog>
  );
}